import "./polyfills";
import React from "react";
import ReactDOM from "react-dom";
import ResizeObserver from 'resize-observer-polyfill';
import * as serviceWorker from "./serviceWorker";
import { HashRouter } from "react-router-dom";
import "./assets/base.scss";
import Main from "./Modules/Main";
import { Provider } from "react-redux";
import "./index.css"
import store from "./store/store.js";

if (!window.ResizeObserver) {
  window.ResizeObserver = ResizeObserver;
}
const rootElement = document.getElementById("root");

const renderApp = (Component) => {
  ReactDOM.render(
    <Provider store={store}>
      <HashRouter>
        <Component />
      </HashRouter>
    </Provider>,
    rootElement
  );
};

renderApp(Main);

if (module.hot) {
  module.hot.accept("./Modules/Main", () => {
    const NextApp = require("./Modules/Main").default;
    renderApp(NextApp);
  });
}
serviceWorker.unregister();
